// extracted by mini-css-extract-plugin
export default {"container":"Quotas_container__9DO1e","link":"Quotas_link__8mXtR","filter":"Quotas_filter__Xoo6O","filterSmall":"Quotas_filterSmall__ZvGg2"};